export default import.meta.ROLLDOWN_FILE_URL_Yvc5_Iz5yPMFYKAwsoZ_8w